<template>
  <v-row class="ma-0">
    <v-col>
      <div v-if="zones.zonesChanges.existing.length < 1" class="no-zone">
        <span>{{ $t('map.tolldomains.overview.no_existing_zones') }}</span>
        <img :src="require('@/assets/images/overview-world-empty.svg')" alt="overview-world-empty" />
      </div>
      <div v-if="zones.zonesChanges.existing.length > 0" class="map-container">
        <l-map
          v-if="mapLoaded"
          ref="existing-zones-map"
          :options="{ preferCanvas: true }"
          @ready="onMapReady"
        >
          <l-tile-layer v-bind="tilesOpts" />
        </l-map>
      </div>
    </v-col>
    <v-col class="col-5 pa-0 overview-container">
      <span class="confirm-zones">{{ $t('map.tolldomains.overview.confirm_zones_1') }}
        <br>{{ $t('map.tolldomains.overview.confirm_zones_2') }}</span>
      <v-row class="list-card">
        <v-col class="pa-0">
          <v-row class="ma-0">
            <div class="list-card-title mb-3">{{ $t('map.tolldomains.overview.existing_zones_list') }}</div>
          </v-row>
          <v-row class="ma-0">
            <div v-if="zones.zonesChanges.existing.length > 0" class="list-container">
              <div class="column-header">
                <span>&nbsp;</span>
                <span>{{ $t('map.tolldomains.global_information.identifier') }}</span>
                <span>{{ $t('map.tolldomains.global_information.tsp_code') }}</span>
                <span>{{ $t('map.tolldomains.global_information.country_code') }}</span>
                <span>{{ $t('map.tolldomains.global_information.provider_identifier') }}</span>
                <span>&nbsp;</span>
              </div>
            </div>
          </v-row>
          <v-row class="ma-0">
            <div class="list-container">
              <div v-for="(zone, index) in existingZones" :key="zone.code" class="list-item-container">
                <span class="item-header">
                  <v-img
                    contain
                    :src="require('@/assets/zones/circle_check.svg')"
                    :aspect-ratio="4 / 2"
                  /></span>
                <span>{{ zone.id }}</span>
                <span class="text-capitalize">{{ zone.name }}</span>
                <span class="text-uppercase">{{ zone.code }}</span>
                <span>{{ zone.providerId || 0 }}</span>
                <span class="zoneVisibility" :class="[zoneVisibility[index] ? 'zoneActive' : 'zoneInactive']" @click="displayMap(zone.code, index)" />
              </div>
            </div>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import L from 'leaflet';
import { LMap, LTileLayer } from 'vue2-leaflet';
import { MAP_ATTRIBUTION, TILES_URL } from '@/constants/map/mapConstants';
import { GeoJsonObject } from 'geojson';

@Component({
  components: {
    LMap,
    LTileLayer
  }
})
export default class OverviewExistingZones extends Vue {
  @Prop()
  private index!: number;

  @Prop()
  private zones!: any;

  @Prop()
  private mapLoaded!: boolean;

  private geoGroup: L.FeatureGroup;

  private zoneVisibility:boolean[] = [];

  private existingZones = [];

  private map: L.Map;

  private tilesOpts = {
    url: TILES_URL,
    attribution: MAP_ATTRIBUTION
  };

  private layerStyle = {
    color: '#94d890',
    weight: 2,
    opacity: 1
  };

  private layers: any = {};

  private onMapReady() {
    const mapComponent = this.$refs['existing-zones-map'] as LMap;
    mapComponent.mapObject.invalidateSize();
    this.geoGroup = L.featureGroup();
    this.map = mapComponent.mapObject;
    // Zones that will be removed are in missing but they're part of the current state
    this.existingZones = this.zones.zonesChanges.existing.concat(this.zones.zonesChanges.missing);
    this.zoneVisibility = Array(this.existingZones.length).fill(true);
    this.existingZones.forEach((zone: any) => {
      const geo = JSON.parse(zone.geo);
      this.addLayer(zone.code, geo);
    });
    this.map.fitBounds(this.geoGroup.getBounds());
  }

  private displayMap(id: string, index: number) {
    this.$set(this.zoneVisibility, index, !this.zoneVisibility[index]);
    if (this.layers[id].toggle) {
      this.layers[id].map.remove();
    } else {
      this.layers[id].map.addTo(this.map);
    }
    this.layers[id].toggle = !this.layers[id].toggle;
  }

  private addLayer(name: string, map: GeoJsonObject) {
    const layer = L.geoJSON(map, { style: this.layerStyle }).addTo(this.map);
    this.geoGroup.addLayer(layer);
    this.layers[name] = { toggle: true, map: layer };
  }
}
</script>
<style lang="scss" scoped>
@import './styles/overview-existing-zones.scss';
</style>
